<template>
    <div class="ma-2">
        <v-row>
            <v-col cols="12" class="align-center d-flex">
                <span class="text-h5">Dashboard Canais</span>
            </v-col>
            <v-col cols="12">
                <div class="lighten-3 elevation-4 pa-4">
                    <div class="d-flex align-center border-b">
                        <span class="text-h7 mr-2">Visualizar apenas valores customizados:</span>
                        <v-switch v-model="onlyFinancial" @change="resetForm"></v-switch>
                    </div>
                    <div class="d-flex align-center mt-2">
                        <span>Por padrão o sistema carrega os dados do <b>mês fiscal</b>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                        <v-icon color="primary" size="16">
                                            mdi-help-circle
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>O mês fiscal tem início no primeiro dia do mês<br> e a data final é o dia atual menos três dias.<br> Caso o mês esteja no ínicio, por exemplo o segundo dia do mês,<br> será exibido o mês anterior menos três dias a partir da data atual. </span>
                            </v-tooltip>
                        </span>
                    </div>
                    <v-form ref="form" v-model="valid" v-if="!onlyFinancial">
                        <v-row>
                            <v-col cols="12" md="3">
                                <span class="mr-2 grey--text text--darken-3">Data inicial: </span>
                                <v-text-field
                                    :disabled="filter"
                                    class="mr-4"
                                    type="date"
                                    v-model="dateIni"
                                    :rules="[moment(dateIni).format('yyyy/MM/DD') <= moment().format('yyyy/MM/DD') || 'A data inserida não pode ser maior que a data atual', rules.required]" >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <span class="mr-2 grey--text text--darken-3">Data final: </span>
                                <v-text-field
                                    :disabled="filter"
                                    v-model="dateEnd"
                                    type="date"
                                    :rules="[moment(dateEnd).format('yyyy/MM/DD') <= moment().format('yyyy/MM/DD') || 'A data inserida não pode ser maior que a data atual', dateIni <= dateEnd || 'A data inical não pode ser maior que a data final', rules.required]">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex align-end">
                                <v-select
                                    :disabled="filter"
                                    v-model="channelSelected"
                                    :items="channels"
                                    item-text="name"
                                    item-value="id"
                                    label="Canais"
                                    :rules="[rules.required]"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex align-center">
                                <v-btn
                                    :disabled="!valid"
                                    color="#1c579a"
                                    class="white--text button-primary elevation-2"
                                    @click="filter = !filter"
                                >
                                    <span v-if="!filter">Aplicar Filtros</span>
                                    <span v-else >Gerar novo Filtro</span>

                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-form ref="form" v-model="valid" v-else>
                        <v-row>
                            <v-col cols="12" md="3" class="d-flex align-end">
                                <v-select
                                    :disabled="filter"
                                    v-model="channelSelected"
                                    :items="channels"
                                    item-text="name"
                                    item-value="id"
                                    label="Canais"
                                    :rules="[rules.required]"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="9" class="d-flex align-center justify-end">
                                <v-btn
                                    :disabled="!valid"
                                    color="#1c579a"
                                    class="white--text button-primary elevation-2"
                                    @click="filter = !filter"
                                >
                                    <span v-if="!filter">Aplicar Filtros</span>
                                    <span v-else >Gerar novo Filtro</span>

                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="elevation-1">
                    <v-tabs
                        background-color="#263238"
                        dark
                        v-model="tab"
                        grow
                        show-arrows
                    >
                        <v-tab v-if="!onlyFinancial">Dossiê</v-tab>
                        <v-tab v-if="(permissions.indexOf('view_monetary_data') != -1) && !onlyFinancial" @click.once="loadMeta = true">Metas</v-tab>
                        <v-tab v-if="(permissions.indexOf('view_monetary_data') != -1) && !onlyFinancial" @click.once="loadReport = true">Report</v-tab>
                        <v-tab v-if="(permissions.indexOf('manage_channels') != -1) && !onlyFinancial" @click.once="loadFinancial = true">Valores Customizados</v-tab>
                        <v-tab v-if="(permissions.indexOf('manage_channels') != -1 && onlyFinancial)">Valores Customizados</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-if="!onlyFinancial">
                            <app-component-empty-state v-if="!filter" :text="'Preencha os campos acima e clique em “Aplicar Filtros”'"></app-component-empty-state>
                            <div v-else class="pa-4">
                                <app-dashboard-dossie :channel="channelSelected" :dateIni="dateIni" :dateEnd="dateEnd"></app-dashboard-dossie>
                            </div>
                        </v-tab-item>
                        <v-tab-item v-if="!onlyFinancial">
                            <app-component-empty-state v-if="!filter && loadMeta" :text="'Preencha os campos acima e clique em “Aplicar Filtros”'"></app-component-empty-state>
                            <div v-if="filter && loadMeta" class="pa-4">
                                <app-dashboard-meta :channel="channelSelected" :dateIni="dateIni" :dateEnd="dateEnd"></app-dashboard-meta>
                            </div>
                        </v-tab-item>
                        <v-tab-item v-if="!onlyFinancial">
                            <app-component-empty-state v-if="!filter" :text="'Preencha os campos acima e clique em “Aplicar Filtros”'"></app-component-empty-state>
                            <div v-if="filter && loadReport" class="pa-4">
                                <app-dashboard-report :channel="channelSelected" :dateIni="dateIni" :dateEnd="dateEnd"></app-dashboard-report>
                            </div>
                        </v-tab-item>
                        <v-tab-item>
                            <app-component-empty-state v-if="!filter" :text="'Preencha os campos acima e clique em “Aplicar Filtros”'"></app-component-empty-state>
                             <div v-if="filter && (onlyFinancial || loadFinancial)" class="pa-4">
                                <app-dashboard-financial :channel="channelSelected"></app-dashboard-financial>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </v-col>
        </v-row>
        <v-snackbar
            v-model="notification.active"
            :top="true"
            :color="notification.type"
            >
            {{ notification.description }}
                <v-btn
                color="white"
                text
                @click="notification.active = false"
            >
                {{ notification.closeText }}
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import moment from 'moment'
import DashboardReport from './DashboardChannelReport.vue'
import DashboardMeta from './DashboardChannelMeta.vue'
import DashboardFinancial from './DashboardChannelFinancial.vue'
import DashboardDossie from './DashboardChannelDossie.vue'
import EmptyState from '../components/EmptyState.vue'

export default {
    created() {
        this.getChannels();
        const token = this.$jwt.decode();
        if ( token ) {
            this.permissions = token.data.permissions;
        }

        if (parseInt(moment().format('d')) < 4) {
            const dataIni = moment().subtract(1, 'month').calendar();
            const dataEnd = moment().subtract(3, 'days');
            this.dateIni = moment(dataIni).format('yyyy-MM-DD');
            this.dateEnd = moment(dataEnd).format('yyyy-MM-DD');
        } else {
            this.dateIni = moment().format('yyyy-MM-01');
            this.dateEnd = moment().format('yyyy-MM-DD')
        }
    },
    components: {
        'app-dashboard-report': DashboardReport,
        'app-dashboard-meta': DashboardMeta,
        'app-dashboard-financial': DashboardFinancial,
        'app-dashboard-dossie': DashboardDossie,
        'app-component-empty-state': EmptyState
    },
    data: () => ({
        filter: false,
        dateEnd: '',
        dateIni: '',
        onlyFinancial: false,
        notification: {
            active: false,
            description: '',
            type: '',
            closeText: ''
        },
        loading: false,
        loadMeta: false,
        loadReport: false,
        loadFinancial: false,
        moment: moment,
        permissions: '',
        valid: false,
        rules: {
            required: value => !!value || 'Este campo é obrigatório.'
        },
        channels: [],
        channelSelected: '',
        tab: null
    }),
    methods: {
        bloqCalendar(event) {
            event.preventDefault();
            return false;
        },
        getChannels() {
            this.$http.get( '/channel/allowed' )
            .then( ( res ) => {
                this.channels = res.data.map(channel => {
                    return {
                        id: channel.id_youtube_channel,
                        name: channel.name
                    }
                })
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro ao buscar os canais.',
                    type: 'error',
                    closeText: 'Fechar'
                };
            })
        },
        resetForm() {
            this.dateEnd = '';
            this.dateIni = '';
            this.channelSelected = '';
            this.filter = false;
        }
    }
}
</script>

<style>

</style>